'use client';

import { createContext, useContext, ReactNode } from 'react';
import { ConnectionStatus } from '@/components/ui/connection-status';

interface OfflineProviderProps {
  children: ReactNode;
}

export const OfflineProvider = ({ children }: OfflineProviderProps) => {
  return (
    <>
      {children}
      <div className="app-offline-status">
        <ConnectionStatus />
      </div>
    </>
  );
};